import { FC } from 'react';
import { Button, Dialog } from '@optimus-web/core';
import { lt, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface ExceedMaximumCapacityDialogProps {
    active: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ExceedMaximumCapacityDialog: FC<ExceedMaximumCapacityDialogProps> = ({ active, onClose, onConfirm }) => (
    <Dialog
        active={active}
        footer={{
            primary: (
                <Button onClick={onConfirm} type="submit" variant="destructive">
                    {lt('Continue')}
                </Button>
            ),
            secondary: (
                <Button onClick={onClose} type="submit" variant="ghost">
                    {lt('GoBack')}
                </Button>
            ),
        }}
        title={<LocalizedText textKey={TextKey.ExceedMaximumCapacityPrompt} />}
        onClose={onClose}
    />
);
